import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-traffic-settings',
  templateUrl: './traffic-settings.component.html',
  styleUrls: ['./traffic-settings.component.scss']
})
export class TrafficSettingsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
